import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import AddProveedor from "../components/AddProveedor";
import TableProveedores from "../components/TableProveedores";
import "../css/admin.css";
import Footer from "../components/Footer";

const Proveedores = () => {
  const [user, setUser] = useState(null);   // guarda usuario decodificado
  const [show, setShow] = useState(false);

  const token = localStorage.getItem("token") || "";   // ← SIN JSON.parse

  useEffect(() => {
    if (!token) {
      setUser(null);
      return;
    }
    try {
      const decoded = jwt_decode(token); // decodifica el JWT (string)
      // si tu payload es { usuario: {...}, iat, exp, ... }
      setUser(decoded?.usuario || null);
    } catch (e) {
      console.error("Token inválido:", e);
      setUser(null);
    }
  }, [token]);

  const isLogged = !!token;                 // true si hay token
  const isAdmin  = user?.role === "ADMIN_ROLE";

  return (
    <>
      <div className="cabecera">
        {isLogged ? (
          <div className="container mt-5">
            <div className="row">
              {isAdmin ? (
                <>
                  <div className="">
                    <h3 className="mt-3 mb-2">GESTION DE PROVEEDORES</h3>
                    <hr />
                  </div>
                  <div className="mt-3 mb-3">
                    <AddProveedor setShow={setShow} show={show} />
                  </div>
                  <div className="mt-3 mb-3">
                    {!show && <TableProveedores />}
                  </div>
                </>
              ) : (
                <div className="col">
                  <div className="alert alert-info" role="alert">
                    Lo sentimos, pero no tiene permisos para acceder a este contenido
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="container mt-5">
            <div className="row">
              <div className="col">
                <div className="alert alert-danger" role="alert">
                  No se encuentra logueado en la plataforma
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Proveedores;
